// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__1lIG0","label":"style_label__2XQeQ","select":"style_select__RjESN"};